import React from "react";
import DriverBehaviorPanel from "../../components/driverSafety/DriverBehaviorPanel";

export default function DriverBehaviorPage() {
  return (
    <div style={{ padding: "24px", maxWidth: "1100px" }}>
      <h1>Driver behavior</h1>
      <p>Photos saved from the cabin camera for this organization.</p>
      <DriverBehaviorPanel />
    </div>
  );
}
